module.exports = __webpack_public_path__ + "assets/img/rb.eb81e482.png";